import { panic } from "./panic";

export function action<T>(
    callback: (obj: T) => Promise<any>,
    refetch: () => void,
) {
    return (obj: T) => {
        return async (ev: Event) => {
            ev.preventDefault();
            ev.stopPropagation();
            try {
                await callback(obj);
            } catch (err: any) {
                panic(err);
            }
            refetch();
        };
    };
};
